import { Button, Header } from '@components/Generic'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import { axiosInstance } from '@methods/axiosConfig'
import { devLog } from '@methods/devLog'
import { forceRedirect } from '@methods/forceRedirect'
import { API_URL, ONBOARDING_SERVICE_PATH } from '@constants/apiUrl'

interface Mock {
  label: string
  scenario: string
}

export const MocksPage = observer(() => {
  const [mocks, setMocks] = useState<Mock[]>([{ label: 'Select scenario', scenario: '' }])
  const [selectedMock, setSelectedMock] = useState<string>('')

  const getMocks = async () => {
    try {
      const res = await axiosInstance.get(`${API_URL}/${ONBOARDING_SERVICE_PATH}/mock/scenarios`, {
        withCredentials: true,
      })
      res.data &&
        setMocks([
          ...mocks,
          ...res.data.map((mock: Mock) => {
            return {
              value: mock.scenario,
              label: mock.scenario,
            }
          }),
        ])
    } catch (e) {
      devLog(e)
    }
  }

  useEffect(() => {
    getMocks()
  }, [])

  const handleProceed = async () => {
    forceRedirect(`${API_URL}/${ONBOARDING_SERVICE_PATH}/mock/redirect?scenario=${selectedMock}`)
  }

  return (
    <div className="page-container mobile-m-0">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Header>Select mock scenario</Header>
        <select
          title="Mock scenarios"
          style={{ width: '300px', padding: '15px', margin: '20px 0' }}
          onChange={(e) => {
            setSelectedMock(e.target.value)
          }}
        >
          {mocks.length > 0 ? (
            mocks.map((mock, v) => (
              <option key={'mock-option' + v} value={mock.scenario}>
                {mock.label}
              </option>
            ))
          ) : (
            <option disabled value="">
              No mock scenarios
            </option>
          )}
        </select>

        <Button onClick={handleProceed} disabled={!selectedMock}>
          Proceed
        </Button>
      </div>
    </div>
  )
})
